import WebApi from '@/views/loyalty/shared/modules/web_api'
import { unwrapEnvelope, envelopeError } from '@/views/skud/shared/modules/skud-http'

export class SkudPassEndpoint {
  constructor () {
    this.url = `${process.env.VUE_APP_CHARON_URL}api/management/`
    this.webApi = new WebApi()
  }

  /**
   * UPsert пропуска (субъект + карты + право). Идемпотентен по (place_id, subject_ref).
   * body: {subject_ref, role_code?, group_ref?, state, card_uids[], grant_type, schedule_id?, valid_from?, valid_to?, point_ids[]}
   * @returns {Promise<{ok: true, data: {subject_id, pass_id, revision}} | {ok: false, error: string}>}
   */
  async upsertPass (placeId, body) {
    const res = await this.webApi.post(this.url + 'places/' + placeId + '/pass/upsert', body)
    const data = unwrapEnvelope(res)
    if (data) return { ok: true, data: data }
    return { ok: false, error: envelopeError(res) || 'Ошибка при сохранении пропуска' }
  }

  /**
   * Отзыв субъекта: блокирует subject, pass_flat каскадно удаляется.
   * @returns {Promise<{ok: true, data: {pass_id, revision}} | {ok: false, error: string}>}
   */
  async revokePass (placeId, subjectRef) {
    const res = await this.webApi.post(this.url + 'places/' + placeId + '/pass/revoke', { subject_ref: subjectRef })
    const data = unwrapEnvelope(res)
    if (data) return { ok: true, data: data }
    return { ok: false, error: envelopeError(res) || 'Ошибка при отзыве пропуска' }
  }
}
